/**
 * The languages the player app is offered in. Serbian is ekavian, Croatian and
 * Bosnian ijekavian. Each has locales/<code>/translation.json (the app) and,
 * except English, locales/<code>/betting.json (the provider's market and
 * selection names, and the market descriptions).
 */
export const APP_LANGUAGES = [
  'en',
  'de',
  'sr',
  'hr',
  'bs',
  'it',
  'fr',
  'sq',
  'tr',
  'es',
] as const;

export type AppLanguage = (typeof APP_LANGUAGES)[number];

/** Languages the provider's English names are translated into. */
export type TranslatedLanguage = Exclude<AppLanguage, 'en'>;

/** The app language for an i18next code ("sr", "sr-RS"...), English otherwise. */
export const appLanguageOf = (raw?: string | null): AppLanguage => {
  const code = String(raw ?? '')
    .slice(0, 2)
    .toLowerCase();
  return (APP_LANGUAGES as readonly string[]).includes(code)
    ? (code as AppLanguage)
    : 'en';
};

/**
 * The locale to hand Intl (dates, weekday names) for an app language: plain
 * "sr" makes Intl write Serbian in Cyrillic ("четвртак"), the app is Latin.
 */
export const intlLocaleOf = (raw?: string | null): string => {
  const lang = appLanguageOf(raw);
  return lang === 'sr' ? 'sr-Latn' : lang;
};
